import React, { useEffect } from "react";
import { Row, Col, Card } from "antd";

type HistoryProps = {
  updateSidebar: (e: string) => void;
};

const IowaHistory = [
  {
    name: "Runablaze Iowa History",
    link: "Blazing-history.pdf",
  },
  {
    name: "Iowa All-Time Road Race Record Lists",
    link: "Iowa-Records.pdf",
  },
  {
    name: "Iowa's best Road Races - Stories",
    link: "Iowa-Records-the-story.pdf",
  },
  {
    name: "Iowa's Best Marathoners - top 5 men & women",
    link: "Iowa-best-Marathoners.pdf",
  },
  {
    name: "Iowa Summer Big 4 - great memories",
    link: "Iowa-Summer-Races.pdf",
  },
  {
    name: "Iowa's Oldest 36 Races",
    link: "Iowa-oldest-races.pdf",
  },
  {
    name: "Iowa Yearly Race History, 1970s",
    link: "1970s.pdf",
  },
  {
    name: "Iowa Yearly Race History, 1980s",
    link: "1980s.pdf",
  },
  {
    name: "Iowa Yearly Race History, 1990s",
    link: "1990s.pdf",
  },
  {
    name: "Iowa Yearly Race History, 2000s",
    link: "2000s.pdf",
  },
  {
    name: "Iowa Yearly Race History, 2010s",
    link: "2010s.pdf",
  },
  {
    name: "Iowa Yearly Race History, 2020s",
    link: "2020s.pdf",
  },
];
const IowaRaceHistory = [
  {
    name: "QC Times Bix 7 History and Records",
    link: "BIX-7.pdf",
  },
  {
    name: "Capital Pursuit 10M History and Records",
    link: "Cap-Pursuit.pdf",
  },
  {
    name: "Dam to Dam (now Dam to DSM) History",
    link: "DAM-history.pdf",
  },
  {
    name: "Dam to Dam Records (1980-2018)",
    link: "Dam-records.pdf",
  },
  {
    name: "Des Moines Marathon",
    link: "DSM-Marathon.pdf",
  },
  {
    name: "Drake Relays Road Race History",
    link: "Drake-road-history.pdf",
  },
  {
    name: "Drake Relays Road Race 10km (1988-1992)",
    link: "Drake-road-10k.pdf",
  },
  {
    name: "Drake Relays Road Race Marathon",
    link: "Drake-road-marathon.pdf",
  },
  {
    name: "Fifth Season 8k Records and History",
    link: "Fifth-season-8k.pdf",
  },
  {
    name: "Living History Farms",
    link: "LHF-results.pdf",
  },
  {
    name: "Marshalltown 10km Records (1986-2016)",
    link: "Marshalltown-10k.pdf",
  },
  {
    name: "Midnight Madness History and Records",
    link: "Midnight-madness.pdf",
  },
  {
    name: "Park to Park Half Marathon Records (2001-2018)",
    link: "Park-to-park.pdf",
  },
  {
    name: "Sturgis Falls Records",
    link: "Sturgis-falls.pdf",
  },
  {
    name: "Quad Cities Marathon Records",
    link: "QC-Marathon.pdf",
  },
  {
    name: "Other Iowa Races including Blazing 5k",
    link: "other-RACES.pdf",
  },
];
const XcHistory = [
  {
    name: "CIML boys & girls state champions",
    link: "CIML.pdf",
  },
  {
    name: "Heartland Classic XC Meet Records",
    link: "Heartland-Classic-XC.pdf",
  },
  {
    name: "Marshalltown CC Bobcat Course Records",
    link: "Bobcat-Invite-XC.pdf",
  },
];

type HistoryItem = {
  name: string;
  link: string;
};

export default function History(props: HistoryProps) {
  const { updateSidebar } = props;

  useEffect(() => {
    updateSidebar("Iowa Running History");
  }, [updateSidebar]);

  const makeHistoryLink = (history: HistoryItem) => {
    return (
      <Row key={history.name} style={{ paddingBottom: 10 }}>
        <a
          href={`/history/${history.link}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          {history.name}
        </a>
      </Row>
    );
  };

  return (
    <div>
      <Row style={{ paddingTop: 10 }}>
        <Col span={24} md={12} style={{ padding: 5 }}>
          <Card title={<b>History of Iowa Races</b>} style={{ height: "100%" }}>
            {IowaRaceHistory.map((history) => {
              return makeHistoryLink(history);
            })}
          </Card>
        </Col>
        <Col span={24} md={12} style={{ padding: 5 }}>
          <Card
            title={<b>History of Iowa Athletes</b>}
            style={{ height: "100%" }}
          >
            {IowaHistory.map((history) => {
              return makeHistoryLink(history);
            })}
            <br />
            <b>High School Cross Country</b>
            <br />
            <br />
            {XcHistory.map((history) => {
              return makeHistoryLink(history);
            })}
          </Card>
        </Col>
      </Row>
      <Col span={24} style={{ padding: 5 }}>
        <Card style={{ padding: 5 }}>
          <h4>
            History documents maintained by Cal Murdock -{" "}
            <a
              href="/history/CAL-history.pdf"
              rel="noopener noreferrer"
              target="_blank"
              style={{ textDecoration: "underline" }}
            >
              Cal's running history
            </a>
          </h4>
          Questions or comments about Iowa Running History? Email{" "}
          <a href="mailto:calmurdock@earthlink.net">calmurdock@earthlink.net</a>
        </Card>
      </Col>
    </div>
  );
}
